export default {
  s: '%d секунд',
  smicro: '%d с',
  smid: '%d сек',

  ss: '%d секунды',
  ssmicro: '%d s',
  ssmid: '%d сек',

  m: '%d минута',
  mmicro: '%d м',
  mmid: '%d мин',

  mm: '%d минуты',
  mmmicro: '%d м',
  mmmid: '%d мин',

  h: '%d час',
  hmicro: '%d ч',
  hmid: '%d час',

  hh: '%d часа',
  hhmicro: '%d ч',
  hhmid: '%d часа',

  d: '%d день',
  dmicro: '%d д',
  dmid: '%d дня',

  dd: '%d дня',
  ddmicro: '%d д',
  ddmid: '%d дня',
};
